module.exports = __webpack_public_path__ + "static/media/lemon-pie.c81e5843.jpg";